<web-settings-breadcrumbs>
    <div class="breadcrumb-icon">
        <a (click)="onCancel()">
            <img src="./assets/img/websites/lpc-back-icon.svg" class="first-breadcrumb-icon" alt="lpc-back-icon" />
        </a>
    </div>
    <div class="breadcrumb-text">
        <span>{{ "shop_cart_style" | translate }}</span>
    </div>
</web-settings-breadcrumbs>

<div class="panel-options-body overflow-wrapper">
    <div class="form form-horizontal">
        <div class="form-group mb-20">
            <label class="col-xs-6 control-label">
                {{ "shop_cart_preview_size" | translate }}
            </label>
            <div class="col-xs-6">
                <sp-radio-group
                    [selected]="previewSize.value"
                    [type]="ERadioGroupType.size"
                    (changeSelectedEvent)="setPreviewSize($event)"
                ></sp-radio-group>
            </div>
        </div>

        <div class="form-group mb-20">
            <label class="col-xs-9 control-label">
                {{ "control_separator" | translate }}
            </label>
            <div class="col-xs-3">
                <sp-switch
                    class="pull-right"
                    [active]="isSeparatedItems.value"
                    (toggleActiveEvent)="setIsSeparatedItems($event)"
                ></sp-switch>
            </div>
        </div>

        <div class="form-row mb-0">
            @if (isSeparatedItems.value) {
                <div class="form-group">
                    <div class="col-xs-4">
                        <sp-input-num
                            suffixText="px"
                            [min]="SIZE_MIN"
                            [max]="SIZE_MAX"
                            [value]="separatorWidth.value"
                            (valueChange)="setSeparatorWidth($event)"
                        ></sp-input-num>
                    </div>
                    <div class="col-xs-6">
                        <select class="form-control" [formControl]="separatorType">
                            <option [ngValue]="ELineStyle.SOLID">{{ "control_solid" | translate }}</option>
                            <option [ngValue]="ELineStyle.DASHED">{{ "control_dashed" | translate }}</option>
                            <option [ngValue]="ELineStyle.DOTTED">{{ "control_dotted" | translate }}</option>
                        </select>
                    </div>
                    <div class="col-xs-2">
                        <web-color-picker
                            [color]="separatorColor.value"
                            (colorChangeEvent)="setSeparatorColor($event)"
                            [hideGradient]="true"
                        ></web-color-picker>
                    </div>
                </div>
            }
        </div>

        <hr class="panel-options-divider" />

        <div class="title">
            {{ "shop_cart_typography" | translate }}
        </div>

        <div class="form-row">
            <div class="form-group mb-20">
                <label class="col-xs-12">{{ "shop_cart_product_title" | translate }}</label>
                <div class="col-xs-4">
                    <sp-input-num
                        suffixText="px"
                        [max]="FONT_SIZE_MAX"
                        [value]="itemTitleFontSize.value"
                        (valueChange)="setItemFontSize(itemTitleFontSize, $event)"
                    ></sp-input-num>
                </div>
                <div class="col-xs-6">
                    <div class="btn-group btn-group-justified" data-toggle="buttons">
                        <label
                            class="btn btn-grey active"
                            [class.active]="isActiveTextStyle(itemTitleFontStyle, EFontStyle.AT)"
                            (click)="setFontStyle(itemTitleFontStyle, EFontStyle.AT)"
                        >
                            <img src="./assets/img/lpc-icon-uppercase.svg" alt="AT" />
                        </label>

                        <label
                            class="btn btn-grey"
                            [class.active]="isActiveTextStyle(itemTitleFontStyle, EFontStyle.B)"
                            (click)="setFontStyle(itemTitleFontStyle, EFontStyle.B)"
                        >
                            <img src="./assets/img/lpc-icon-bold.svg" alt="B" />
                        </label>

                        <label
                            class="btn btn-grey"
                            [class.active]="isActiveTextStyle(itemTitleFontStyle, EFontStyle.I)"
                            (click)="setFontStyle(itemTitleFontStyle, EFontStyle.I)"
                        >
                            <img src="./assets/img/lpc-icon-italic.svg" alt="I" />
                        </label>
                    </div>
                </div>
                <div class="col-xs-2">
                    <web-color-picker
                        [hideGradient]="true"
                        [color]="itemTitleFontColor.value"
                        (colorChangeEvent)="setItemColor($event, itemTitleFontColor)"
                    ></web-color-picker>
                </div>
            </div>

            <div class="form-group mb-20">
                <label class="col-xs-12">{{ "shop_cart_product_options" | translate }}</label>
                <div class="col-xs-4">
                    <sp-input-num
                        suffixText="px"
                        [max]="FONT_SIZE_MAX"
                        [value]="itemPropertyFontSize.value"
                        (valueChange)="setItemFontSize(itemPropertyFontSize, $event)"
                    ></sp-input-num>
                </div>
                <div class="col-xs-6">
                    <div class="btn-group btn-group-justified" data-toggle="buttons">
                        <label
                            class="btn btn-grey active"
                            [class.active]="isActiveTextStyle(itemPropertyFontStyle, EFontStyle.AT)"
                            (click)="setFontStyle(itemPropertyFontStyle, EFontStyle.AT)"
                        >
                            <img src="./assets/img/lpc-icon-uppercase.svg" alt="AT" />
                        </label>

                        <label
                            class="btn btn-grey"
                            [class.active]="isActiveTextStyle(itemPropertyFontStyle, EFontStyle.B)"
                            (click)="setFontStyle(itemPropertyFontStyle, EFontStyle.B)"
                        >
                            <img src="./assets/img/lpc-icon-bold.svg" alt="B" />
                        </label>

                        <label
                            class="btn btn-grey"
                            [class.active]="isActiveTextStyle(itemPropertyFontStyle, EFontStyle.I)"
                            (click)="setFontStyle(itemPropertyFontStyle, EFontStyle.I)"
                        >
                            <img src="./assets/img/lpc-icon-italic.svg" alt="I" />
                        </label>
                    </div>
                </div>
                <div class="col-xs-2">
                    <web-color-picker
                        [hideGradient]="true"
                        [color]="itemPropertyFontColor.value"
                        (colorChangeEvent)="setItemColor($event, itemPropertyFontColor)"
                    ></web-color-picker>
                </div>
            </div>

            <div class="form-group mb-20">
                <label class="col-xs-12">{{ "shop_cart_price_options" | translate }}</label>
                <div class="col-xs-4">
                    <sp-input-num
                        suffixText="px"
                        [max]="FONT_SIZE_MAX"
                        [value]="itemPriceFontSize.value"
                        (valueChange)="setItemFontSize(itemPriceFontSize, $event)"
                    ></sp-input-num>
                </div>
                <div class="col-xs-6">
                    <div class="btn-group btn-group-justified" data-toggle="buttons">
                        <label
                            class="btn btn-grey active"
                            [class.active]="isActiveTextStyle(itemPriceFontStyle, EFontStyle.AT)"
                            (click)="setFontStyle(itemPriceFontStyle, EFontStyle.AT)"
                        >
                            <img src="./assets/img/lpc-icon-uppercase.svg" alt="AT" />
                        </label>

                        <label
                            class="btn btn-grey"
                            [class.active]="isActiveTextStyle(itemPriceFontStyle, EFontStyle.B)"
                            (click)="setFontStyle(itemPriceFontStyle, EFontStyle.B)"
                        >
                            <img src="./assets/img/lpc-icon-bold.svg" alt="B" />
                        </label>

                        <label
                            class="btn btn-grey"
                            [class.active]="isActiveTextStyle(itemPriceFontStyle, EFontStyle.I)"
                            (click)="setFontStyle(itemPriceFontStyle, EFontStyle.I)"
                        >
                            <img src="./assets/img/lpc-icon-italic.svg" alt="I" />
                        </label>
                    </div>
                </div>
                <div class="col-xs-2">
                    <web-color-picker
                        [hideGradient]="true"
                        [color]="itemPriceFontColor.value"
                        (colorChangeEvent)="setItemColor($event, itemPriceFontColor)"
                    ></web-color-picker>
                </div>
            </div>

            <div class="form-group mb-0">
                <label class="col-xs-12">{{ "shop_cart_total_price_options" | translate }}</label>
                <div class="col-xs-4">
                    <sp-input-num
                        suffixText="px"
                        [max]="FONT_SIZE_MAX"
                        [value]="itemTotalPriceFontSize.value"
                        (valueChange)="setItemFontSize(itemTotalPriceFontSize, $event)"
                    ></sp-input-num>
                </div>
                <div class="col-xs-6">
                    <div class="btn-group btn-group-justified" data-toggle="buttons">
                        <label
                            class="btn btn-grey active"
                            [class.active]="isActiveTextStyle(itemTotalPriceFontStyle, EFontStyle.AT)"
                            (click)="setFontStyle(itemTotalPriceFontStyle, EFontStyle.AT)"
                        >
                            <img src="./assets/img/lpc-icon-uppercase.svg" alt="AT" />
                        </label>

                        <label
                            class="btn btn-grey"
                            [class.active]="isActiveTextStyle(itemTotalPriceFontStyle, EFontStyle.B)"
                            (click)="setFontStyle(itemTotalPriceFontStyle, EFontStyle.B)"
                        >
                            <img src="./assets/img/lpc-icon-bold.svg" alt="B" />
                        </label>

                        <label
                            class="btn btn-grey"
                            [class.active]="isActiveTextStyle(itemTotalPriceFontStyle, EFontStyle.I)"
                            (click)="setFontStyle(itemTotalPriceFontStyle, EFontStyle.I)"
                        >
                            <img src="./assets/img/lpc-icon-italic.svg" alt="I" />
                        </label>
                    </div>
                </div>
                <div class="col-xs-2">
                    <web-color-picker
                        [hideGradient]="true"
                        [color]="itemTotalPriceFontColor.value"
                        (colorChangeEvent)="setItemColor($event, itemTotalPriceFontColor)"
                    ></web-color-picker>
                </div>
            </div>
        </div>

        <hr class="panel-options-divider" />

        <div class="title">
            {{ "shop_cart_delete_button_settings" | translate }}
        </div>

        <div class="form-row">
            <div class="form-group mb-20">
                <div class="col-xs-10">
                    <label class="control-label">{{ "shop_cart_icon_color" | translate }}</label>
                </div>
                <div class="col-xs-2">
                    <web-color-picker
                        [hideGradient]="true"
                        [color]="deleteButtonIconColor.value"
                        (colorChangeEvent)="setItemColor($event, deleteButtonIconColor)"
                    ></web-color-picker>
                </div>
            </div>

            <div class="form-group mb-0">
                <div class="col-xs-10">
                    <label class="control-label">{{ "shop_cart_icon_bg_color" | translate }}</label>
                </div>
                <div class="col-xs-2">
                    <web-color-picker
                        [hideGradient]="true"
                        [color]="deleteButtonBgColor.value"
                        (colorChangeEvent)="setItemColor($event, deleteButtonBgColor)"
                    ></web-color-picker>
                </div>
            </div>
        </div>

        <hr class="panel-options-divider" />

        <div class="title">
            {{ "shop_cart_items_count_button_settings" | translate }}
        </div>

        <div class="form-row">
            <!-- <div class="form-group mb-20">
      <div class="col-xs-10">
        <label class="control-label">{{ 'shop_cart_items_count_button_color' | translate }}</label>
      </div>
      <div class="col-xs-2">
        <web-color-picker
          [hideGradient]="true"
          [color]="countButtonColor.value"
          (colorChangeEvent)="setItemColor($event, countButtonColor)"
        ></web-color-picker>
      </div>
    </div> -->

            <div class="form-group mb-20">
                <div class="col-xs-10">
                    <label class="control-label">{{ "shop_cart_items_count_button_text_color" | translate }}</label>
                </div>
                <div class="col-xs-2">
                    <web-color-picker
                        [hideGradient]="true"
                        [color]="countButtonTextColor.value"
                        (colorChangeEvent)="setItemColor($event, countButtonTextColor)"
                    ></web-color-picker>
                </div>
            </div>

            <div class="form-group mb-20">
                <div class="col-xs-10">
                    <label class="control-label">{{ "shop_cart_items_count_button_bg_color" | translate }}</label>
                </div>
                <div class="col-xs-2">
                    <web-color-picker
                        [hideGradient]="true"
                        [color]="countButtonBgColor.value"
                        (colorChangeEvent)="setItemColor($event, countButtonBgColor)"
                    ></web-color-picker>
                </div>
            </div>

            <div class="form-group mb-20">
                <div class="col-xs-10">
                    <label class="control-label">{{ "shop_cart_items_count_button_border_color" | translate }}</label>
                </div>
                <div class="col-xs-2">
                    <web-color-picker
                        [hideGradient]="true"
                        [color]="countButtonBorderColor.value"
                        (colorChangeEvent)="setItemColor($event, countButtonBorderColor)"
                    ></web-color-picker>
                </div>
            </div>

            <div class="form-group mb-20">
                <div class="col-xs-6">
                    <label class="control-label">{{ "control_radius" | translate }}</label>
                </div>
                <div class="col-xs-6">
                    <sp-input-num
                        prefixImgUrl="./assets/img/border-radius-icon.svg"
                        suffixText="px"
                        [min]="BORDER_RADIUS_MIN"
                        [max]="BORDER_RADIUS_MAX"
                        [value]="countButtonRounding.value"
                        (valueChange)="setCountButtonRounding($event)"
                        (blurEvent)="setCountButtonRounding($event)"
                    ></sp-input-num>
                </div>
            </div>

            <div class="form-group mb-0">
                <div class="col-xs-6">
                    <label class="control-label">{{ "shop_cart_field_size" | translate }}</label>
                </div>
                <div class="col-xs-6">
                    <sp-radio-group
                        [selected]="countButtonSize.value"
                        [type]="ERadioGroupType.size"
                        (changeSelectedEvent)="setCountButtonSize($event)"
                    ></sp-radio-group>
                </div>
            </div>
        </div>

        <div class="form-group mb-20"></div>
    </div>
</div>

<web-settings-footer (saveEvent)="onSave()" (cancelEvent)="onReset()"></web-settings-footer>
